import { render, staticRenderFns } from "./RoleDist.vue?vue&type=template&id=0c9e2549"
import script from "./RoleDist.vue?vue&type=script&lang=js"
export * from "./RoleDist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports